import {
  AppBar,
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Typography,
  withStyles,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import SendIcon from '@material-ui/icons/SendRounded';
import AttachFile from '@material-ui/icons/AttachFileRounded';
import { makeStyles, useTheme } from '@material-ui/styles';
import { Link, useHistory, useLocation } from 'react-router-dom';
import routes from '../../../../../Utils/routes.json';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import EditOutlined from '@material-ui/icons/EditOutlined';
import React, { useEffect, useState } from 'react';
import KenCard from '../../../../../global_components/KenCard';
import KenGrid from '../../../../../global_components/KenGrid';
import KenDialogBox from '../../../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../../../global_components/KenSelect';
import { RiFilterLine } from 'react-icons/ri';
import Kentable from '../../../../../global_components/KenTable/kentable';
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Message,
} from '@material-ui/icons';
import ChatLayout from '../../../components/ChatLayout';
import ChatInput from '../../../components/ChatInput';
import moment from 'moment';
import BreadCrumb from '../../../../../Components/BreadCrumb';
import KenSlider from '../../../../../global_components/KenSlider';
import KenInputField from '../../../../../global_components/KenInputField';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, registerables } from 'chart.js';
import { AiFillDelete } from 'react-icons/ai';
import { getGradingDetails } from '../../../../../Utils/apiServices';
import LastPageIcon from '@material-ui/icons/LastPage';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import PropTypes from 'prop-types';

ChartJS.register(...registerables);

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '10px',
    lineHeight: '150%',
    textTransform: 'uppercase',
    color: '#505F79',
    padding: 20,
  },
  body: {
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '100%',
    color: '#505F79',
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  // root: {
  //   '&:nth-of-type(odd)': {
  //     backgroundColor: theme.palette.action.hover,
  //   },
  // },
}))(TableRow);

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}
TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const dataChart = {
  // x- axis
  labels: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
  datasets: [
    {
      label: 'Percentage',
      data: [0, 0, 0, 5, 35, 45, 77, 47, 18, 5, 0],
      fill: true,
      backgroundColor: 'rgba(9, 0, 119, 0.3)',
      borderColor: 'rgba(99, 87, 255, 1)',
    },
  ],
};

const legend = {
  display: true,
  position: 'left',
  labels: {
    fontColor: '#323130',
    fontSize: 14,
  },
};

const options = {
  plugins: {
    title: {
      display: true,
      text: 'Number of Student',
      position: 'left',
    },

    legend: {
      display: true,
      position: 'bottom',
    },
  },
  scales: {
    yAxes: [
      {
        ticks: {
          suggestedMin: 0,
          suggestedMax: 100,
        },
      },
    ],
  },
};
const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'GRADING',
    url: routes.grading,
  },
  {
    head: 'SUBJECT 1',
  },
];

const chatData = [
  {
    sender: true,
    message: `Hey, Could you please let me know which chapters I have to cover
  in UX/UI paper?`,
    profilePic: 'https://ptetutorials.com/images/user-profile.png',
    time: '3 days ago',
  },
  {
    sender: false,
    message: `Hi Nandhini, you should include first 8 chapters in mid semester
    exam.`,
    profilePic: '',
    time: '3 days ago',
  },
  {
    sender: true,
    message: `Okay, Thank you gentleman!`,
    profilePic: 'https://ptetutorials.com/images/user-profile.png',
    time: '3 days ago',
  },
];
const selectOptionsCourse = [
  {
    label: 'ABSOLUTE',
    value: 'Absolute',
  },
  {
    label: 'RELATIVE',
    value: 'relative',
  },
];

const data = [
  {
    id: 1,
    student_list: <Link>Wade Warren</Link>,
    test_first: '50',
    test_second: '67',
    mid_term: '45',
    end_term: '25',
    project: '24',
    total_score: '350',
    calculated_grade: 'A',
    penalties: <Link style={{ color: '#F14B2D' }}>Acadmic Misconduct</Link>,
    final_grade: 'A',
  },
  {
    id: 2,
    student_list: <Link>Cameron Williamson</Link>,
    test_first: '50',
    test_second: '89',
    mid_term: '42',
    end_term: '24',
    project: '24',
    total_score: '350',
    calculated_grade: 'C',
    penalties: <Link style={{ color: '#F14B2D' }}>Low Attendence</Link>,
    final_grade: 'B',
  },
  {
    id: 3,
    student_list: <Link>Cameron Williamson</Link>,
    test_first: '40',
    test_second: '45',
    mid_term: '25',
    end_term: '24',
    project: '24',
    total_score: '350',
    calculated_grade: 'A',
    penalties: <Link style={{ color: '#F14B2D' }}>Discipliner Issue</Link>,
    final_grade: 'C',
  },
  {
    id: 4,
    student_list: <Link>Esther Howard</Link>,
    test_first: '20',
    test_second: '25',
    mid_term: '42',
    end_term: '28',
    project: '24',
    total_score: '350',
    calculated_grade: 'B',
    penalties: <Link style={{ color: '#F14B2D' }}>Acadmic Misconduct</Link>,
    final_grade: 'B',
  },
  {
    id: 5,
    student_list: <Link>Wade Warren</Link>,
    test_first: '50',
    test_second: '48',
    mid_term: '85',
    end_term: '24',
    project: '24',
    total_score: '350',
    calculated_grade: 'A',
    penalties: <Link style={{ color: '#F14B2D' }}>Acadmic Misconduct</Link>,
    final_grade: 'C',
  },
  {
    id: 6,
    student_list: <Link>Cameron Williamson</Link>,
    test_first: '50',
    test_second: '54',
    mid_term: '24',
    end_term: '23',
    project: '24',
    total_score: '350',
    calculated_grade: 'C',
    penalties: <Link style={{ color: '#F14B2D' }}>Acadmic Misconduct</Link>,
    final_grade: 'A',
  },
  {
    id: 7,
    student_list: <Link>Jane Cooper</Link>,
    test_first: '30',
    test_second: '25',
    mid_term: '54',
    end_term: '35',
    project: '24',
    total_score: '350',
    calculated_grade: 'B',
    penalties: <Link style={{ color: '#F14B2D' }}>Acadmic Misconduct</Link>,
    final_grade: 'B',
  },
  {
    id: 8,
    student_list: <Link>Wade Warren</Link>,
    test_first: '40',
    test_second: '25',
    mid_term: ' 24',
    end_term: '54',
    project: '24',
    total_score: '350',
    calculated_grade: 'A',
    penalties: <Link style={{ color: '#F14B2D' }}>Acadmic Misconduct</Link>,
    final_grade: 'A',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  subHeaderTitle: {
    width: '100%',
  },
  modalHeader: {
    fontWeight: 'normal',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    '& p': {
      marginRight: '25px',
    },
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    borderBottom: '1px solid transparent',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid transparent',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    color: '#FFFFFF',
    background: '#EB5757',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '70%',
  },
  normal: {
    color: '#FFFFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '70%',
  },
  editbtn: {
    color: '#FFFFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '100px',
  },
  Blue: {
    color: '#FFFFFF',
    background: '#00218D',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '70%',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '70%',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
  table: {
    minWidth: 700,
    padding: 10,
  },
  tbCourseTerm: {
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '100%',
    color: '#02195E',
  },
  containerModify: {
    marginTop:16,
    paddingBottom:12,
    paddingLeft:12,
    paddingRight:12,
    flex: 1,
    overflowY: 'scroll',
    overflowX: 'hidden',
    border: '1px solid #C4C4C4',
    borderRadius: '5px',
    minHeight: '55vh',
    maxHeight: '65vh',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      opacity: '0.2',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#C4C4C4',
      borderRadius: '30px',
      opacity: '0.1',
      outline: `1px solid transparent`,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: `#02195E`,
    },
  },
}));

const selectOptionsCampus = [
  {
    label: 'Select Campus',
    value: '--Select--',
  },
  {
    label: 'Campus 1',
    value: '1',
  },
  {
    label: 'Campus 2',
    value: '2',
  },
];

const selectOptionsProgram = [
  {
    label: 'Select Program',
    value: '--Select--',
  },
  {
    label: 'Program 1',
    value: '1',
  },
  {
    label: 'Program 2',
    value: '2',
  },
];

const selectOptionsSubject = [
  {
    label: 'Select Subject',
    value: '--Select--',
  },
  {
    label: 'Subject 1',
    value: '1',
  },
  {
    label: 'Subject 2',
    value: '2',
  },
];

const selectOptionsTerm = [
  {
    label: 'Select Term',
    value: '--Select--',
  },
  {
    label: 'Term 1',
    value: '1',
  },
  {
    label: 'Term 2',
    value: '2',
  },
];

const selectOptionsBatch = [
  {
    label: 'Select Batch',
    value: '--Select--',
  },
  {
    label: 'Batch 1',
    value: '1',
  },
  {
    label: 'Batch 2',
    value: '2',
  },
];

const UserCellBulkMessage = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const sendBulkDataGrid = [
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Raleigh Avieson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Fleur Fowler'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Nealy Leitch'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Carolyne Angrock'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Abeu Aiers'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Penny Scrivinor'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Grier Laverick'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Dur Leile'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Claudine Owenson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Stefa True'
    ),
  },
];
const minDistance = 10;

const GradingDetails = () => {
  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [gradeSubmit, setGradSubmit] = useState(true);
  const [gradeSubmitRelative, setGradSubmitRelative] = useState(true);
  const location = useLocation();
  const [gradingId, setGradingId] = useState(location?.state?.gradingId);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  var arr = [
    {
      minmum: 0,
      maximum: 0,
    },
  ];
  const arraySilder = arr.map(({ maximum, minmum }) => [maximum, minmum]);

  const [valueSilder, setValueSilder] = useState(arraySilder);

  // states
  const [objSlider, setObjSlider] = useState([
    {
      value: [86, 100],
      cgpa: 10,
      grade: 'A+',
    },
    {
      value: [71, 85],
      cgpa: 9,
      grade: 'A',
    },
    {
      value: [56, 70],
      cgpa: 8,
      grade: 'B',
    },
    {
      value: [41, 56],
      cgpa: 7,
      grade: 'B+',
    },
  ]);

  const [objSliderRelative, setObjSliderRelative] = useState([
    {
      value: [86, 100],
      cgpa: 10,
      grade: 'A+',
    },
    {
      value: [71, 85],
      cgpa: 9,
      grade: 'A',
    },
    {
      value: [56, 70],
      cgpa: 8,
      grade: 'B',
    },
    {
      value: [41, 56],
      cgpa: 7,
      grade: 'B+',
    },
  ]);
  // Automatic select
  const [selectValueCourse, setSelectValueCourse] = useState(
    selectOptionsCourse[0].value
  );
  const [selectValueCampus, setSelectValueCampus] = useState(
    selectOptionsCampus[0].value
  );
  const [selectValueBatch, setSelectValueBatch] = useState(
    selectOptionsBatch[0].value
  );
  const [selectValueSubject, setSelectValueSubject] = useState(
    selectOptionsSubject[0].value
  );
  const [selectValueTerm, setSelectValueTerm] = useState(
    selectOptionsTerm[0].value
  );
  const [messageDialog, setMessageDialog] = useState(false);
  const [chats, setChats] = useState(chatData);
  const [typedMessage, setTypedMessage] = useState(
    'Anytime, You are always welcome!'
  );
  const [selectValueProgram, setSelectValueProgram] = useState(
    selectOptionsProgram[0].value
  );
  const [filterDialog, setFilterDialog] = useState(false);
  const [selectAllData, setSelectAllData] = useState(false);
  const [cgpaInp, setFacultyInp] = useState({
    first: 10,
    second: 9,
    third: 8,
    forth: 7,
    fifth: 6,
  });
  const [gradeInp, setGradeInp] = useState({
    first: 'A+',
    second: 'A',
    third: 'B+',
    forth: 'B',
    fifth: 'C',
  });
  const [commonInp, setCommonInput] = useState({});
  const [sendBulkMessageDialog, setSendBulkMessageDialog] = useState(false);
  const [sliderDialog, setSliderDialog] = useState(false);
  const [discard, setDiscard] = useState(false);
  const [discardRelated, setDiscardRelated] = useState(false);
  const [dataArray, setDataArray] = useState([]);
  // Editing
  const [dataOfTable, setDataOfTable] = useState(data);

  const handleChangeSlider = (e, index, newValue) => {
    let valueSlider = e.target.value.split('-');
    const arrData = valueSlider.map((ele) => parseInt(ele));
    if (!Array.isArray(arrData)) {
      return;
    }
    if (true) {
      setObjSlider((prevState) => {
        return prevState.map((single, i) => {
          if (i === index) {
            return { ...single, value: [arrData[0] || 0, arrData[1] || 0] };
          } else {
            return single;
          }
        });
      });
    }
  };

  const handleChangeSliderRelative = (e, index, newValue) => {
    let valueSlider = e.target.value.split('-');
    const arrData = valueSlider.map((ele) => parseInt(ele));
    if (!Array.isArray(arrData)) {
      return;
    }
    if (arrData[0] >= 0 && arrData[1] <= 100) {
      setObjSliderRelative((prevState) => {
        return prevState.map((single, i) => {
          if (i === index) {
            return { ...single, value: [arrData[0] || 0, arrData[1] || 0] };
          } else {
            return single;
          }
        });
      });
    }
  };
  useEffect(() => {
    // setObjSlider(pre => pre)
    setDataGradAbsolute(dataGrad);
  }, [objSlider]);
  useEffect(() => {
    setDataGradRelated(dataGradRelative);
  }, [objSliderRelative]);
  const handleChange2 = (e, index, newValue) => {
    if (!Array.isArray(newValue)) {
      return;
    }
    setObjSlider((prevState) => {
      return prevState.map((single, i) => {
        if (i === index) {
          return { ...single, value: newValue };
        } else {
          return single;
        }
      });
    });
  };

  let arrVal = [];
  const handleOnChangeCommitted = (check) => {
    let arr = [];
    objSlider.forEach((ele) => {
      arr = [...arr, ...ele.value];
    });
    for (let i = 0; i < arr.length; i = i + 2) {
      if (arr[i] <= arr[i + 3]) {
        setGradSubmit(false);
        toast.error('Please Enter the Correct Range');
        return;
      } else {
        if (check && gradeSubmit) {
          toast.success('submit succesfully');
          handleClickSlider();
          setGradSubmit(true);
        }
        setGradSubmit(true);
        return;
      }
    }
  };
  const submitHandlerRelative = (check) => {
    let arr = [];
    objSliderRelative.forEach((ele) => {
      arr = [...arr, ...ele.value];
    });
    for (let i = 0; i < arr.length; i = i + 2) {
      if (arr[i] <= arr[i + 3]) {
        setGradSubmitRelative(false);
        toast.error('Please Enter the Correct Range');
        return;
      } else {
        if (check && gradeSubmitRelative) {
          toast.success('submit succesfully');
          handleClickSlider();
          setGradSubmitRelative(true);
        }
        setGradSubmitRelative(true);
        return;
      }
    }
  };
  const handleOnBlur = () => {
    let arr = [];
    objSlider.forEach((ele) => {
      arr = [...arr, ...ele.value];
    });
    for (let i = 0; i < arr.length; i = i + 2) {
      if (arr[i] <= arr[i + 3]) {
        toast.error('Please Enter the Correct Range');
        return;
      } else {
        return;
      }
    }
  };

  const handleChange = (event, rows, index) => {
    setObjSlider((prevState) => {
      return prevState.map((single, i) => {
        if (i === index) {
          return { ...single, grade: event.target.value };
        } else {
          return single;
        }
      });
    });
  };
  const handleChangeRelative = (event, rows, index) => {
    setObjSliderRelative((prevState) => {
      return prevState.map((single, i) => {
        if (i === index) {
          return { ...single, grade: event.target.value };
        } else {
          return single;
        }
      });
    });
  };

  const handleChangeCommon = (event) => {
    setCommonInput({
      [event.target.name]: event.target.value,
    });
  };
  const handleChangeCgpa = (event, rows, index) => {
    setObjSlider((prevState) => {
      return prevState.map((single, i) => {
        if (i === index) {
          return { ...single, cgpa: event.target.value };
        } else {
          return single;
        }
      });
    });
  };
  const handleChangeCgpaRelative = (event, rows, index) => {
    setObjSliderRelative((prevState) => {
      return prevState.map((single, i) => {
        if (i === index) {
          return { ...single, cgpa: event.target.value };
        } else {
          return single;
        }
      });
    });
  };
  const gradCell = (rows, i) => {
    return (
      <Box>
        <Grid item xs={12} sm={4}>
          <KenInputField
            name={rows}
            value={rows}
            optionalLabel={false}
            onChange={(e) => handleChange(e, rows, i)}
            style={{ fontSize: 12 }}
          />
        </Grid>
      </Box>
    );
  };
  const gradCellRelative = (rows, i) => {
    return (
      <Box>
        <Grid item xs={12} sm={4}>
          <KenInputField
            name={rows}
            value={rows}
            optionalLabel={false}
            onChange={(e) => handleChangeRelative(e, rows, i)}
            style={{ fontSize: 12 }}
          />
        </Grid>
      </Box>
    );
  };

  const deleteCell = (rows) => {
    return <AiFillDelete size={20} onClick={() => handleDelete(rows)} />;
  };

  const deleteCellRelative = (rows) => {
    return (
      <AiFillDelete size={20} onClick={() => handleDeleteRelative(rows)} />
    );
  };
  const cgpaCell = (rows, i) => {
    return (
      <Box>
        <Grid item xs={12} sm={3}>
          <KenInputField
            name={rows}
            optionalLabel={false}
            value={rows}
            dropdownColor="#ffffff"
            onChange={(e) => handleChangeCgpa(e, rows, i)}
            style={{ fontSize: 12 }}
          />
        </Grid>
      </Box>
    );
  };
  const cgpaCellRelative = (rows, i) => {
    return (
      <Box>
        <Grid item xs={12} sm={3}>
          <KenInputField
            name={rows}
            optionalLabel={false}
            value={rows}
            dropdownColor="#ffffff"
            onChange={(e) => handleChangeCgpaRelative(e, rows, i)}
            style={{ fontSize: 12 }}
          />
        </Grid>
      </Box>
    );
  };
  const dataGrad = objSlider.map((ele, i) => {
    return {
      id: i + 1,
      precentile_range:
        selectValueCourse === 'Absolute' ? (
          <KenSlider
            value2={ele.value}
            handleChange2={(e, value) => handleChange2(e, i, value, 0)}
            handleOnChangeCommitted={() => handleOnChangeCommitted()}
          />
        ) : (
          ''
        ),
      percentile: (
        <Grid item xs={12} sm={5}>
          <KenInputField
            optionalLabel={false}
            value={ele.value.join('-')}
            onChange={(e, value) => handleChangeSlider(e, i, value, 0)}
            onBlur={() => handleOnBlur()}
            style={{ fontSize: 12 }}
          />
        </Grid>
      ),
      cgpa: cgpaCell(ele.cgpa, i),
      grade_name: gradCell(ele.grade, i),
      delete: deleteCell(i + 1),
    };
  });

  const dataGradRelative = objSliderRelative.map((ele, i) => {
    return {
      id: i + 1,
      percentile1: (
        <Grid item xs={12} sm={6}>
          <KenInputField
            // label={'Average/Mean'}
            optionalLabel={false}
            // rows={4}
            // multiline={true}
            value={ele.value.join('-')}
            onChange={(e, value) => handleChangeSliderRelative(e, i, value, 0)}
            style={{ fontSize: 12 }}
          />
        </Grid>
      ),
      cgpa1: cgpaCellRelative(ele.cgpa, i),
      grade_name1: gradCellRelative(ele.grade, i),
      delete1: deleteCellRelative(i + 1),
    };
  });
  const [avaerage, setAverage] = useState(8);
  const [classSize, setclassSize] = useState(100);
  const [deviation, setDeviation] = useState(8);
  const [averageAbsolute, setAverageAbsolute] = useState(8);
  const [classSizeAbsolute, setclassSizeAbsolute] = useState(100);
  const [deviationAbsolute, setDeviationAbsolute] = useState(8);
  const [bottom, setBottom] = useState(8);

  const [dataGridAbsolute, setDataGradAbsolute] = useState(dataGrad);
  const [dataGridRelated, setDataGradRelated] = useState(dataGradRelative);

  const [columnGridAbsolute, setColumnGradAbsolute] = useState([]);
  const [columnGridRelative, setColumnGradRelative] = useState([]);
  const handleDelete = (rows) => {
    setDataGradAbsolute((pre) => pre.filter((item) => item.id !== rows));
    setObjSlider((pre) => pre.filter((item, i) => i + 1 !== rows));
    toast.success('Row delete Sucessfully');
  };
  const handleDeleteRelative = (rows) => {
    setDataGradRelated((pre) => pre.filter((item) => item.id !== rows));
    setObjSliderRelative((pre) => pre.filter((item, i) => i + 1 !== rows));
    toast.success('Row delete Sucessfully');
  };
  function handleMessageDialog() {
    setMessageDialog((prevState) => !prevState);
  }
  const messageChangeHandler = (e) => {
    setTypedMessage(e.target.value);
  };

  const sendMessageHandler = () => {
    if (!typedMessage) {
      return;
    }

    setChats((prev) => {
      return [
        ...prev,
        {
          sender: false,
          message: typedMessage,
          profilePic: '',
          time: moment(new Date()).fromNow(),
        },
      ];
    });
  };
  const handleSelectChangeCourse = (e) => {
    setSelectValueCourse(e.target.value);
  };

  const handleChangeBottom = (e) => {
    setBottom(e.target.value);
  };
  const handleSelectChangeCampus = (e) => {
    setSelectValueCampus(e.target.value);
  };
  const handleClicked = () => {
    handleMessageDialog();
  };

  const handleClickSlider = () => {
    handleSliderDialog();
  };

  const handleSelectChangeProgram = (e) => {
    setSelectValueProgram(e.target.value);
  };

  const handleSelectChangeSubject = (e) => {
    setSelectValueSubject(e.target.value);
  };

  const handleSelectChangeTerm = (e) => {
    setSelectValueTerm(e.target.value);
  };

  const handleSelectChangeBatch = (e) => {
    setSelectValueBatch(e.target.value);
  };

  function handleFilterDialog() {
    console.log('dataa');
    setFilterDialog((prevState) => !prevState);
  }

  function handleSendBulkMessageDialog() {
    setSendBulkMessageDialog((prevState) => !prevState);
  }

  function handleSliderDialog() {
    console.log('data');
    setSliderDialog((prevState) => !prevState);
  }
  function positiveClick() {
    console.log('data');
    handleOnChangeCommitted(true);
  }
  function positiveClickRelative() {
    // handleOnChangeCommitted(true);
    submitHandlerRelative(true);
    console.log('first');
  }
  const handleSelectRow = (evt, row, index) => {
    // TODO code here to perform actions on selecting row in table
  };

  const handleSelectAllRows = (state) => {
    // TODO code here to perform actions on selecting all rows in table
    setSelectAllData(state);
  };

  const columns = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'STUDENT LIST',
      accessor: 'student_list',
      disableGlobalFilter: true,
    },
    {
      Header: 'TEST 1 (10 %)',
      accessor: 'test_first',
      disableGlobalFilter: true,
    },
    {
      Header: 'TEST 2 (10 %)',
      accessor: 'test_second',
      disableGlobalFilter: true,
    },
    {
      Header: 'MID-TERM (20 %)',
      accessor: 'mid_term',
      disableGlobalFilter: true,
      // Cell: QuestionPaperCell,
    },
    {
      Header: 'END-TERM (40 %)',
      accessor: 'end_term',
      disableGlobalFilter: true,
      // Cell: QuestionPaperCell,
    },
    {
      Header: 'PROJECT (20 %)',
      accessor: 'project',
      disableGlobalFilter: true,
      // Cell: QuestionPaperCell,
    },
    {
      Header: 'TOTAL SCORE',
      accessor: 'total_score',
      disableGlobalFilter: true,
      // Cell: QuestionPaperCell,
    },
    {
      Header: 'CALCULATED GRADE',
      accessor: 'calculated_grade',
      disableGlobalFilter: true,
      // Cell: QuestionPaperCell,
    },
    {
      Header: 'PENALTIES',
      accessor: 'penalties',
      disableGlobalFilter: true,
      // Cell: QuestionPaperCell,
    },
    {
      Header: 'FINAL GRADE',
      accessor: 'final_grade',
      disableGlobalFilter: true,
    },
  ];
  const columnGrad = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: selectValueCourse === 'Absolute' ? 'Precentile Range' : '',
      accessor: 'precentile_range',
      disableGlobalFilter: true,
    },
    {
      Header: selectValueCourse === 'Absolute' ? 'percentage' : 'percentile',
      accessor: 'percentile',
      disableGlobalFilter: true,
    },
    {
      Header: 'CGPA',
      accessor: 'cgpa',
      disableGlobalFilter: true,
    },
    {
      Header: 'Grade name',
      accessor: 'grade_name',
      disableGlobalFilter: true,
      // Cell: QuestionPaperCell,
    },
  ];

  const columnGradRelative = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'percentile',
      accessor: 'percentile1',
      disableGlobalFilter: true,
    },
    {
      Header: 'CGPA',
      accessor: 'cgpa1',
      disableGlobalFilter: true,
    },
    {
      Header: 'Grade name',
      accessor: 'grade_name1',
      disableGlobalFilter: true,
      // Cell: QuestionPaperCell,
    },
  ];

  const handleAddRow = () => {
    let objNewSlider = {
      value: [0, 0],
      cgpa: '--',
      grade: '--',
    };
    setObjSlider((preState) => [...preState, objNewSlider]);
    toast.success('Row Added Sucessfully');
  };
  const handleNewRowRelative = () => {
    let objNewSlider = {
      value: [0, 0],
      cgpa: '--',
      grade: '--',
    };
    setObjSliderRelative((preState) => [...preState, objNewSlider]);
    toast.success('Row Added Sucessfully');
  };

  const handleDiscard = () => {
    setDiscard(!discard);
    if (discard) {
      columnGrad.push({
        Header: 'Delete',
        accessor: 'delete',
        disableGlobalFilter: true,
      });
    }
    setColumnGradAbsolute(columnGrad);
  };

  const handleDiscardRelative = () => {
    setDiscardRelated(!discardRelated);
    if (discardRelated) {
      columnGradRelative.push({
        Header: 'Delete',
        accessor: 'delete1',
        disableGlobalFilter: true,
      });
    }
    setColumnGradRelative(columnGradRelative);
  };
  const handleSaveRow = () => {
    toast.success('save successfully');
  };

  const handleChangeAverage = (e) => {
    setAverage(e.target.value);
  };
  const handleChangeAverageAbsolute = (e) => {
    setAverageAbsolute(e.target.value);
  };
  const handleChangeDeviationAbsolute = (e) => {
    setDeviationAbsolute(e.target.value);
  };
  const handleChangeClassSizeAbsolute = (e) => {
    setclassSizeAbsolute(e.target.value);
  };
  const handleChangeDeviation = (e) => {
    setDeviation(e.target.value);
  };

  const handleChangeClassSize = (e) => {
    setclassSize(e.target.value);
  };
  // dependency useEffect
  useEffect(() => {
    setColumnGradRelative(columnGradRelative);
  }, []);
  useEffect(() => {
    setColumnGradAbsolute(columnGrad);
  }, []);
  /* grading details API call */
  const [studentList, setStudentList] = useState([]);
  useEffect(() => {
    getGradingDetails(gradingId)
      .then((res) => {
        console.log(
          'Object.values(res[0]?.studentList[0])',
          Object.values(res[0]?.studentList[0])
        );
        const dataList = [];
        for (let value of Object.entries(res[0]?.studentList[0])) {
          dataList.push({ ...value[1], rollNumber: value[0] });
        }
        console.log('dataList', dataList);
        setStudentList(dataList);
      })
      .catch((err) => {
        console.log('grading error', err);
      });
  }, []);
  console.log('StudentList', studentList);

  /* table pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, studentList.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box>
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Grading
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              // onClick={handleFilterDialog}
            >
              Save
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.addButton}
              // onClick={handleSendBulkMessageDialog}
              style={{ marginRight: '15px' }}
            >
              Send for Approval
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={handleClicked}
            >
              Send back for amendments
            </Button>
          </Grid>
        </Toolbar>
      </AppBar>
      <AppBar
        position="static"
        elevation={0}
        className={classes.header}
        // style={{ marginLeft: '610px' }}
      >
        <Toolbar
          style={{
            color: '#505F79',
            fontWeight: 'bold',
            borderTop: '1px solid #D7DEE9',
          }}
        >
          <Grid
            item
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'end',
              alignItems: 'center',
            }}
          >
            <Typography variant="p" style={{ marginRight: '25px' }}>
              No of student:15
            </Typography>
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={handleClickSlider}
            >
              Edit Grading Details
            </Button>
            <Grid item>
              <KenSelectWrap
                options={selectOptionsCourse}
                value={selectValueCourse}
                dropdownColor="#FFFFFF"
                onChange={handleSelectChangeCourse}
                required
              />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      {/*  <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <KenGrid
            columns={columns}
            data={dataOfTable}
            pagination={{ disabled: true }}
            toolbarDisabled={true}
            initialState={{
              hiddenColumns: ['id'],
            }}
            gridProps={{
              getCellProps: (row) => {
                if (
                  row.column.Header === 'Send Message' ||
                  row.column.Header === 'Edit'
                ) {
                  return {
                    style: {
                      textAlign: 'center',
                    },
                  };
                }
                return {
                  style: {
                    textAlign: 'left',
                  },
                };
              },
              getHeaderProps: (column) => {
                if (
                  column.Header === 'Send Message' ||
                  column.Header === 'Edit'
                ) {
                  return {
                    style: {
                      textAlign: 'center',
                    },
                  };
                }
                return {
                  style: {
                    textAlign: 'left',
                  },
                };
              },
            }}
          />
        </KenCard>
      </Box> */}
      {/* Message Modal */}
      {/* <KenSlider value2={value2} handleChange2={handleChange2} /> */}
      <ToastContainer />
      <KenDialogBox
        title={
          <Typography
            variant="p"
            className={classes.modalHeader}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <p>
              <img
                style={{ borderRadius: '50%', marginRight: '10px' }}
                width="40"
                height="40"
                src={'http://dummyimage.com/174x172.png/5fa2dd/ffffff'}
                alt="user"
              />
              {'Faculty 1'}
            </p>
            <p>Subject 1, Subject 2, Subject 3</p>
            <p>Room 1</p>
            <Typography variant="p">Monday, 10th January, 2022</Typography>{' '}
          </Typography>
        }
        open={messageDialog}
        handleClose={() => handleMessageDialog()}
        hidePositiveButton={true}
        hideNegativeButton={true}
        maxWidth="md"
        dividers
      >
        <div className="chat-box-part">
          <ChatLayout chats={chats} />

          <ChatInput
            typedMessage={typedMessage}
            messageChangeHandler={messageChangeHandler}
            sendMessageHandler={sendMessageHandler}
          />
        </div>
      </KenDialogBox>
      {/* Filter Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            EXAM FILTER
          </Typography>
        }
        open={filterDialog}
        handleClose={() => handleFilterDialog()}
        negativeButtonClick={() => handleFilterDialog()}
        positiveButtonClick={() => handleFilterDialog()}
        positiveButtonText="Submit"
        // onChange
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Campus"
              options={selectOptionsCampus}
              value={selectValueCampus}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeCampus}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Program"
              options={selectOptionsProgram}
              value={selectValueProgram}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeProgram}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Subject"
              options={selectOptionsSubject}
              value={selectValueSubject}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeSubject}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Term"
              options={selectOptionsTerm}
              value={selectValueTerm}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeTerm}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Batch"
              options={selectOptionsBatch}
              value={selectValueBatch}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeBatch}
              required
            />
          </Grid>
        </Grid>
      </KenDialogBox>

      {/* Message Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Send Bulk Message
          </Typography>
        }
        open={sendBulkMessageDialog}
        handleClose={() => handleSendBulkMessageDialog()}
        negativeButtonClick={() => handleSendBulkMessageDialog()}
        positiveButtonClick={() => handleSendBulkMessageDialog()}
        positiveButtonText={<SendIcon />}
        negativeButtonText={<AttachFile />}
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Box className="cardlsitbox">
              <KenCard elevation={0}>
                <Kentable
                  data={sendBulkDataGrid}
                  initialState={{
                    hiddenColumns: ['id'],
                  }}
                  allcheckboxData={(state) => handleSelectAllRows(state)}
                  onRowCheckBox={(event, row, index) =>
                    handleSelectRow(event, row, index)
                  }
                />
              </KenCard>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box className="cardlsitbox">
              <KenCard elevation={0}>
                <TextField
                  placeholder="Add Comments"
                  multiline
                  rows={10}
                  maxRows={'Infinity'}
                />
              </KenCard>
            </Box>
          </Grid>
        </Grid>
      </KenDialogBox>
      {/* Slider Modal absolute */}
      {selectValueCourse === 'Absolute' ? (
        <KenDialogBox
          title={<Typography variant="p">GRADING - ABSOLUTE</Typography>}
          open={sliderDialog}
          handleClose={() => handleSliderDialog()}
          negativeButtonClick={() => handleSliderDialog()}
          positiveButtonClick={() => positiveClick()}
          // hidePositiveButton={true}
          // hideNegativeButton={true}
          positiveButtonText="Submit"
          negativeButtonText="Cancel"
          maxWidth="md"
          dividers
        >
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} sm={2}>
              <KenInputField
                label="Average/Mean"
                name={'avaerage'}
                value={averageAbsolute}
                // optionalLabel={false}
                onChange={(e) => handleChangeAverageAbsolute(e)}
                style={{ fontSize: 12 }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <KenInputField
                label={'Standard deviation'}
                name="standard"
                optionalLabel={false}
                // rows={4}
                // multiline={true}
                value={deviationAbsolute}
                onChange={(e) => handleChangeDeviationAbsolute(e)}
                style={{ fontSize: 12 }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <KenInputField
                label={'Bottom value 5%'}
                optionalLabel={false}
                name="bottom"
                // rows={4}
                // multiline={true}
                value={bottom}
                onChange={(e, value3) => handleChangeBottom(e, value3)}
                style={{ fontSize: 19 }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <KenInputField
                label={'Class Size'}
                optionalLabel={false}
                name="classsize"
                value={classSizeAbsolute}
                onChange={(e, value3) =>
                  handleChangeClassSizeAbsolute(e, value3)
                }
                style={{ fontSize: 19 }}
              />
            </Grid>
            <Grid item xs={12} sm={2} style={{ marginTop: '10px' }}>
              <Button
                variant="contained"
                color="primary"
                className={classes.addButton}

                // onClick={handleFilterDialog}
              >
                Edit
              </Button>
            </Grid>
          </Grid>
          <Box className="cardlsitbox">
            <KenCard elevation={0}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <b>Grade letters</b>
                </div>
                <div style={{ display: 'flex' }}>
                  <p
                    style={{
                      cursor: 'pointer',
                      color: '#0077FF',
                      paddingRight: '15px',
                    }}
                    onClick={() => {
                      handleAddRow();
                    }}
                  >
                    Add +
                  </p>
                  <p
                    style={{
                      cursor: 'pointer',
                      color: '#F2564A',
                      paddingRight: '15px',
                    }}
                    onClick={() => {
                      handleDiscard();
                    }}
                  >
                    Discard
                  </p>
                  <p
                    style={{ cursor: 'pointer', color: '#1BBE75' }}
                    onClick={() => {
                      handleSaveRow();
                    }}
                  >
                    Save Changes
                  </p>
                </div>
              </div>
              <hr />
              <KenGrid
                columns={columnGridAbsolute}
                data={dataGridAbsolute}
                pagination={{ disabled: true }}
                toolbarDisabled={true}
                initialState={{
                  hiddenColumns: ['id'],
                }}
              />
            </KenCard>
          </Box>
          {/* <KenSlider value2={value2} handleChange2={handleChange2} /> */}

          {/* <div className="chat-box-part">
          <ChatLayout chats={chats} />

          <ChatInput
            typedMessage={typedMessage}
            messageChangeHandler={messageChangeHandler}
            sendMessageHandler={sendMessageHandler}
          />
        </div> */}
        </KenDialogBox>
      ) : (
        <KenDialogBox
          title={<Typography variant="p">GRADING - RELATIVE</Typography>}
          open={sliderDialog}
          handleClose={() => handleSliderDialog()}
          negativeButtonClick={() => handleSliderDialog()}
          positiveButtonClick={() => positiveClickRelative()}
          // hidePositiveButton={true}
          hideNegativeButton={false}
          positiveButtonText="Submit"
          negativeButtonText="Cancel"
          maxWidth="md"
          dividers
        >
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} sm={2}>
              <KenInputField
                label="Average/Mean"
                name={'avaerage'}
                value={avaerage}
                // optionalLabel={false}
                onChange={(e) => handleChangeAverage(e)}
                style={{ fontSize: 12 }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <KenInputField
                label={'Standard deviation'}
                optionalLabel={false}
                // rows={4}
                // multiline={true}
                value={deviation}
                onChange={(e) => handleChangeDeviation(e)}
                style={{ fontSize: 12 }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <KenInputField
                label={'Class Size'}
                optionalLabel={false}
                // rows={4}
                // multiline={true}
                value={classSize}
                onChange={(e) => handleChangeClassSize(e)}
                style={{ fontSize: 19 }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.addButton}
                // onClick={handleFilterDialog}
              >
                Edit
              </Button>
            </Grid>
          </Grid>
          <div>
            <Box className="cardlsitbox">
              <KenCard elevation={0}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    paddingBottom: '1rem',
                    marginBottom: '1rem',
                    borderBottom: '1px solid #C9C9C9',
                  }}
                >
                  <div>
                    <b>Grade letters</b>
                  </div>
                  <div style={{ display: 'flex' }}>
                    <p
                      style={{
                        color: '#0077FF',
                        paddingRight: '15px',
                      }}
                      onClick={() => {
                        handleNewRowRelative();
                      }}
                    >
                      Add +
                    </p>
                    <p
                      style={{ color: '#F2564A', paddingRight: '15px' }}
                      onClick={() => {
                        handleDiscardRelative();
                      }}
                    >
                      Discard
                    </p>
                    <p style={{ color: '#1BBE75' }}>Save Changes</p>
                  </div>
                </div>
                <Grid container spacing={3} alignItems="center">
                  <Grid item xs={5}>
                    <div className="chart-part" style={{ width: '4  0%' }}>
                      <Line
                        data={dataChart}
                        legend={legend}
                        options={options}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={7}>
                    <KenGrid
                      style={{ width: '60%', padding: '0 15px' }}
                      columns={columnGridRelative}
                      data={dataGridRelated}
                      pagination={{ disabled: true }}
                      toolbarDisabled={true}
                      initialState={{
                        hiddenColumns: ['id'],
                      }}
                    />
                  </Grid>
                </Grid>
              </KenCard>
            </Box>
          </div>
        </KenDialogBox>
      )}
      {/* new table design */}
      <Paper>
        <TableContainer className={classes.containerModify}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell>Student list</StyledTableCell>
                <StyledTableCell>Test 1 (10%) </StyledTableCell>
                <StyledTableCell>Test 2 (10%)</StyledTableCell>
                <StyledTableCell>Mid-term (20%)</StyledTableCell>
                <StyledTableCell>END-TERM (40%)</StyledTableCell>
                <StyledTableCell>PROJECT (20%)</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {studentList &&
                (rowsPerPage > 0
                  ? studentList.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : studentList
                ).map((ele, index) => {
                  return (
                    <StyledTableRow key={ele?.studentName}>
                      <StyledTableCell className={classes.tbCourseTerm}>
                        {ele?.studentName}
                      </StyledTableCell>
                      <StyledTableCell className={classes.tbCourseTerm}>
                        test 1{/* index */}
                      </StyledTableCell>
                      <StyledTableCell>test 2{/* index */}</StyledTableCell>
                      <StyledTableCell>
                        {ele?.midtTermMarks || 0}
                      </StyledTableCell>
                      <StyledTableCell>
                        {ele?.endTermMarks || 0}
                      </StyledTableCell>
                      <StyledTableCell>
                        {ele?.project[0] || 'NA'}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
            </TableBody>
            <TableFooter>
              <StyledTableRow></StyledTableRow>
            </TableFooter>
          </Table>
        </TableContainer>
        <Box style={{display:'flex',justifyContent:'center'}}>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
            colSpan={6}
            count={studentList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            SelectProps={{
              inputProps: { 'aria-label': 'rows per page' },
              native: true,
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default GradingDetails;
